export default __webpack_public_path__ + "static/media/91.917aef3b.gif";